import { resolveDonationType } from "@/stores/donationFormStore";
import { DonationAmountWithConfig } from "@/components/DonationAmount";
import { DonationIntentWithConfig } from "@/components/DonationIntent";
import { useDonationFormStore } from "@/stores";
import { Alert } from "@/components/ui/Alert";
import { Button } from "@/components/ui/Button";
import classes from "./Form.module.scss";
import { useTranslation } from "@/hooks/useTranslation";
import { ImperativeHandle } from "@/types/Form";
import { useRef } from "react";
import { dispatchEvent } from "@/utils/event-dispacher";
import { EventName } from "@/types/Events";
import { CURRENCY } from "@/config";

type FormStepAmountProps = Readonly<{
  onStepSubmit: () => void;
  continueFailed?: boolean;
}>;

export function FormStepAmount(props: FormStepAmountProps) {
  const { onStepSubmit, continueFailed = false } = props;

  const amountFormRef = useRef<ImperativeHandle>(null);

  const {
    donationType,
    donationAmount,
    donationOneOffType,
    donationAmountAcceptedDefault,
  } = useDonationFormStore();

  const showDonationIntent =
    donationType === "one-off" && donationAmount !== null;

  const showSubmitButton =
    donationAmount !== null &&
    (!showDonationIntent || donationOneOffType !== null);

  const t = useTranslation("_common");

  const handleSubmit = async () => {
    const validation = await amountFormRef.current?.validate();
    if (validation?.isValid) {
      dispatchEvent(EventName.SELECT_AMOUNT, {
        amount: donationAmount!,
        currency: CURRENCY,
        donation_type: resolveDonationType(useDonationFormStore.getState())!,
        accepted_default: donationAmountAcceptedDefault === true,
      });
      onStepSubmit();
    }
  };

  return (
    <>
      <DonationAmountWithConfig ref={amountFormRef} />

      {showDonationIntent && (
        <div className={classes.marginBottom}>
          <DonationIntentWithConfig />
        </div>
      )}

      {continueFailed && (
        <div className={classes.marginBottom}>
          <Alert variant="error">{t("continue-error")}</Alert>
        </div>
      )}

      {showSubmitButton && (
        <div className={classes.pagination}>
          <Button size="large" variant="outlined" onClick={handleSubmit}>
            {t("continue")}
          </Button>
        </div>
      )}
    </>
  );
}
